/** Application-wide date display format (DD/MM/YYYY). */
export const APP_DATE_FORMAT = 'DD/MM/YYYY';

const pad2 = (n) => String(n).padStart(2, '0');

/** Format a Date or ISO timestamp as DD/MM/YYYY. */
export function formatAppDate(value) {
  if (value == null || value === '') return '';
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  return `${pad2(d.getDate())}/${pad2(d.getMonth() + 1)}/${d.getFullYear()}`;
}

/** Format an HTML date input value (YYYY-MM-DD) as DD/MM/YYYY. */
export function formatAppDateFromKey(dateKey) {
  if (!dateKey || !/^\d{4}-\d{2}-\d{2}$/.test(dateKey)) return '';
  const [year, month, day] = dateKey.split('-');
  return `${day}/${month}/${year}`;
}

/** Format a from/to period for display (DD/MM/YYYY → DD/MM/YYYY). */
export function formatAppDateRange(fromKey, toKey, separator = ' → ') {
  const from = formatAppDateFromKey(fromKey) || formatAppDate(fromKey);
  const to = formatAppDateFromKey(toKey) || formatAppDate(toKey);
  if (!from || !to) return '';
  return `${from}${separator}${to}`;
}

/** Format date and time as DD/MM/YYYY HH:mm. */
export function formatAppDateTime(value = new Date()) {
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  return `${formatAppDate(d)} ${pad2(d.getHours())}:${pad2(d.getMinutes())}`;
}
